import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { RouterModule } from '@angular/router';
import { AuthCallbackComponent } from './auth-callback/auth-callback.component';
import { BisSecurityDirective } from './bis-security.directive';
import { UtilityModule } from '../utility/utility.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    UtilityModule,
    BisSecurityDirective,
    UnauthorizedComponent, AuthCallbackComponent,
  ],
  exports: [UnauthorizedComponent, BisSecurityDirective],
})
export class AuthModule { }
